
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M0 0h40v40H0z"}}),_c('path',{attrs:{"fill":"#C1C8D6","fill-rule":"nonzero","d":"M15.428 17.589v-3.693l2.646 3.693h1.14V12.09h-1.182v3.56l-2.57-3.56h-1.215v5.498h1.181zm7.513.099c1.68 0 2.903-1.187 2.903-2.844 0-1.657-1.223-2.844-2.903-2.844-1.672 0-2.895 1.187-2.895 2.844 0 1.657 1.223 2.844 2.895 2.844zm0-1.039c-1.023 0-1.68-.783-1.68-1.805 0-1.03.657-1.805 1.68-1.805s1.689.774 1.689 1.805c0 1.022-.666 1.805-1.69 1.805zM8.68 27.893v-5.498H7.5v5.498h1.181zm2.28 0v-3.957l1.564 3.957h.516l1.564-3.957v3.957h1.19v-5.498H14.13l-1.348 3.429-1.348-3.43H9.78v5.499h1.18zm6.639 0l.35-.948h2.478l.35.948h1.29l-2.139-5.498h-1.48l-2.147 5.498H17.6zm2.504-1.962h-1.839l.924-2.522.915 2.522zM25.27 28a3.092 3.092 0 002.363-1.039V24.86h-2.645v1.006h1.48v.668c-.24.214-.69.42-1.198.42-1.006 0-1.738-.766-1.738-1.805s.732-1.805 1.738-1.805a1.58 1.58 0 011.315.692l.982-.528c-.425-.65-1.149-1.203-2.297-1.203-1.622 0-2.953 1.105-2.953 2.844 0 1.73 1.331 2.852 2.953 2.852zm7.23-.107v-1.014h-2.745V25.6h2.687v-1.005h-2.687V23.4H32.5v-1.005h-3.927v5.498H32.5z"}})])])
          )
        }
      }
    